<template>
    <ul :class="['DkbPaging', {'mini': mini}]">
        <!-- prev -->
        <li
        :class="['paging-item ico ico-back', {'paging-item--disabled' : currentIndex === 1}]"
        @click="prev"></li>
 
        <!-- first -->
        <!-- <li
        :class="['paging-item--first', {'paging-item--disabled' : currentIndex === 1}]"
        @click="first">first</li> -->
 
        <li
        :class="['paging-item paging-item--more']"
        v-if="showPrevMore">...</li>
 
        <li
        :class="['paging-item num', {'paging-item--current' : currentIndex === pager}]"
        v-for="(pager, index) in pagers"
        :key="index"
        @click="go(pager)">{{ pager }}</li>
 
        <li
        :class="['paging-item paging-item--more']"
        v-if="showNextMore">...</li>
 
        <!-- last -->
        <!-- <li
        :class="['paging-item--last', {'paging-item--disabled' : currentIndex === pages}]"
        @click="last">last</li> -->
 
        <!-- next -->
        <li
        :class="['paging-item ico ico-right', {'paging-item--disabled' : currentIndex === pages}]"
        @click="next"></li>
    </ul>
</template>

<script>
  let vm

  export default {
    name: 'DkbPaging',
    props : {
      //页面中的可见页码，其他的以...替代, 必须是奇数
      perPages : { 
        type : Number,
        default : 5 
      },
      //当前页码
      pageIndex : {
        type : Number,
        default : 1
      },
      //每页显示条数
      pageSize : {
        type : Number,
        default : 10
      },
      //总记录数
      total : {
        type : Number,
        default : 1
      },
      // 是否小分页
      mini: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        currentIndex : this.pageIndex, //当前页码
        limit : this.pageSize, //每页显示条数
        size : this.total || 1, //总记录数
        showPrevMore : false,
        showNextMore : false
      }
    },
    computed : {
      //计算总页码
      pages(){
        return Math.ceil(this.size / this.limit)
      },
      //计算页码，当count等变化时自动计算
      pagers () {
        const array = []
        const perPages = this.perPages
        const pageCount = this.pages
        let current = this.currentIndex
        const _offset = (perPages - 1) / 2
        const offset = {
          start : current - _offset,
          end   : current + _offset
        }
        //-1, 3
        if (offset.start < 1) {
          offset.end = offset.end + (1 - offset.start)
          offset.start = 1
        }
        if (offset.end > pageCount) {
          offset.start = offset.start - (offset.end - pageCount)
          offset.end = pageCount
        }
        if (offset.start < 1) offset.start = 1
        this.showPrevMore = (offset.start > 1)
        this.showNextMore = (offset.end < pageCount)
 
        for (let i = offset.start; i <= offset.end; i++) {
          array.push(i)
        }
 
        return array
      }
    },
    created () {
      vm = this
    },
    methods : {
      prev(){
        if (this.currentIndex > 1) {
          this.go(this.currentIndex - 1)
        }
      },
      next(){
        if (this.currentIndex < this.pages) {
          this.go(this.currentIndex + 1)
        }
      },
      first(){
        if (this.currentIndex !== 1) {
          this.go(1)
        }
      },
      last(){
        if (this.currentIndex != this.pages) {
          this.go(this.pages)
        }
      },
      go (page) {
        if (this.currentIndex !== page) {
          this.currentIndex = page
          //父组件通过change方法来接受当前的页码
          this.$emit('change', this.currentIndex)
        }
      }
    },
    watch : {
      pageIndex(val) {
        this.currentIndex = val || 1
      },
      pageSize(val) {
        this.limit = val || 10
      },
      total(val) {
        this.size = val || 1
      }
    }
  }
  
</script>

<style lang="scss" scoped>
  // 分页
  .DkbPaging {
    display: flex;
    justify-content: center;
    .paging-item {
      height: 0.26rem;
      line-height: 0.26rem;
      padding: 0 0.06rem;
      font-size: 0.2rem;
      color: #7da4c8;
      box-sizing: border-box;
      position: relative;
        // icon
        &.ico {
          font-size: 0.18rem;
        }
        // ... 
        &.paging-item--more{
          // margin-top: -
        }
        // 禁用
        &.paging-item--disabled {
            cursor: not-allowed;
            opacity: .3;
        }
        &.paging-item--more,
        &.paging-item--current {
            cursor: default;
        }
        // 选中
        &.paging-item--current {
          line-height: 0.24rem;
          border: 0.01rem solid #7da4c8;
          box-shadow: 0 0 0.03rem rgba(123, 159, 195, 0.41);
        }
    }
    .paging-item+.paging-item{
      margin-left: 0.15rem;
    }
  }
  .DkbPaging.mini{
    .paging-item{
      height: 0.18rem;
      line-height: 0.18rem;
      font-size: 0.12rem;
      padding: 0 0.04rem;
        &.ico {
          font-size: 0.16rem;
        }
        &.paging-item--current {
          line-height: 0.16rem;
        }
    }
    .paging-item+.paging-item{
      margin-left: 0.09rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/Layout/DkbPaging.vue